import http from "@/http/aisea/axios";
const resource = "/enterprises/operations/vessels";

export default {
  /**
   * APIでoperationの船舶一覧を取得する
   * @returns {Promise<Object>}
   * @property {boolean} status - APIのリクエストが成功したかどうか
   * @property {number} code - ステータスコード
   * @property {OperationVessel[]} data - データ
   * @property {string} message - メッセージ
   * @throws {Error}
   */
  index() {
    return http.get(`${resource}`);
  },
};
